import { Injectable } from '@angular/core'
import { Meta, Title } from '@angular/platform-browser'

import { environment } from '../../../environments/environment'
import { MetaObject } from '../interfaces/meta-object.interface'

@Injectable({
  providedIn: 'root'
})
export class MetaService {
  constructor(private title: Title, private meta: Meta) {}

  defaultMeta: MetaObject = {
    title: environment.appName,
    description: `A Case app for ${environment.appName}`,
    path: '',
    ogImage: 'assets/images/logo.png'
  }

  setTags(metaObject: MetaObject): void {
    this.title.setTitle(
      `${metaObject.title || this.defaultMeta.title} | ${environment.appName}`
    )
    this.meta.addTags([
      {
        name: 'description',
        content: metaObject.description || this.defaultMeta.description
      },
      {
        name: 'og:description',
        content: metaObject.description || this.defaultMeta.description
      },
      {
        name: 'og:title',
        content: metaObject.title || this.defaultMeta.title
      },
      {
        name: 'og:url',
        content: environment.baseUrl + metaObject.path
      },
      {
        name: 'og:image',
        content:
          environment.baseUrl + (metaObject.ogImage || this.defaultMeta.ogImage)
      }
    ])
  }
}
